import {
  Box,
  Button,
  Modal,
  Typography,
  AppBar,
  Toolbar,
  Divider,
  Snackbar,
  Link,
} from "@mui/material";
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { getLocalizedText } from "../../../../Functions";
import { CopyAll } from "@mui/icons-material";
import { indiamartWebhookDescs, indiamartWebhookHelpURL } from "../../../../Db";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  textAlign: "left",
  margin: "auto",
  backgroundColor: "white",
  height: "100%",
  width: "600px",
}));

const ModelContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  margin: "auto",
  height: "fit-content",
  width: "fit-content",
  border: "none",
  outline: "none",
  backgroundColor: "white",
  boxShadow: "0px 3px 20px #185dd21f",
  borderRadius: "8px",
  padding: "30px",
  border: "1px solid #c5d7f1",
}));

const ButtonWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  position: "relative",
  paddingTop: "16px",
}));

const CodeBlock = styled(Typography)(({ theme }) => ({
  fontFamily: "monospace",
  fontSize: "14px",
  color: "#4d4e4f",
  whiteSpace: "pre-wrap",
  overflowX: "auto",
  paddingRight: "5px",
}));

const TextWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "fit-content",
  overflowY: "auto",
  backgroundColor: "#f5f5f5", // Light grey background for code block
  padding: "12px",
  borderRadius: "4px",
  border: "1px solid #e0e0e0",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const Header = styled(Typography)(({ theme }) => ({
  font: "normal normal 600 18px Open Sans",
  color: "#4d4e4f",
}));

const HeaderWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  height: "100%",
  width: "100%",
}));

const InnerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "600px",
  textAlign: "left",
  margin: "auto",
  backgroundColor: "white",
  height: "100%",
  paddingTop: "16px",
}));

const Label = styled(Typography)(({ theme }) => ({
  font: "normal normal normal 14px Open Sans",
}));

const IndiamartWebhookDialog = ({ open, setOpen, apiKey }) => {
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const apiText = `https://api.leadpixie.ai/api/v3/external/indiamart/${apiKey}`;

  const handleLink = (link_str) => {
    if (link_str !== null && link_str !== "") {
      window.open(link_str, "_blank");
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModelContainer>
        <Container>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            sx={{ top: "auto", bottom: 0, width: "100%", height: "30px" }}
          >
            <Toolbar
              style={{
                padding: "0px",
                width: "100%",
                position: "relative",
                display: "flex",
              }}
            >
              <HeaderWrapper>
                <Header>Connect IndiaMART to LeadPixie</Header>
              </HeaderWrapper>
            </Toolbar>
          </AppBar>
          <Divider />

          <InnerContainer>
            <Box
              style={{
                marginLeft: "10px",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {indiamartWebhookDescs.map((e, i) => {
                return (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: "8px",
                    }}
                  >
                    <Label
                      style={{
                        fontSize: "14px",
                        marginRight: "8px",
                      }}
                    >
                      {(i+1) + "."}
                    </Label>
                    <Label style={{ fontSize: "14px" }}>{e}</Label>
                  </Box>
                );
              })}
            </Box>
            <Box
              style={{
                height: "100%",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  height: "100%",
                  width: "100%",
                  justifyContent: "flex-start",
                }}
              >
                <TextWrapper>
                  <CodeBlock component="pre">{apiText}</CodeBlock>
                  <CopyAll
                    color="primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigator.clipboard.writeText(apiText);
                      setOpenSnackBar(true);
                    }}
                  />
                </TextWrapper>
              </Box>
              <Box sx={{paddingTop: "16px"}}>
                <Typography style={{ fontSize: "14px" }}>
                  Need help? Check{" "}
                  <Link onClick={() => handleLink(indiamartWebhookHelpURL)}>
                    IndiaMART's Integration Guide
                  </Link>
                  .
                </Typography>
              </Box>
            </Box>
          </InnerContainer>

          <ButtonWrapper>
            <Button
              onClick={() => setOpen(false)}
              variant="contained"
              color="inherit"
              style={{
                fontWeight: "bold",
                fontSize: "12px",
                textTransform: "none",
              }}
            >
              {getLocalizedText("close")}
            </Button>
          </ButtonWrapper>
        </Container>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          onClose={() => {
            setOpenSnackBar(false);
          }}
          message="Copied to clipboard!"
        />
      </ModelContainer>
    </Modal>
  );
};

export default IndiamartWebhookDialog;
